<template>
  <div id="top">

    <h1><font color="red">新型コロナウイルス感染症の状況を鑑み、本研究会の開催は中止となりました。</font></h1>

    <h3>趣旨</h3>
    <hr>
    <div class="inline-contents">
      <p>
        <span>&emsp;本研究会では，2015年3月に大阪市立大学で開催した "Mathematics and Physics </span
        ><span>in General Relativity"，2019年3月に摂南大学で開催した The second workshop </span
        ><span>on "Mathematics and Physics in General Relativity" に続き，一般相対論及び</span
        ><span>関連する数学の協働・共創による新たな展開を目指します。</span>
      </p><p>
        <span>&emsp;ブラックホール時空の一意性定理や特異点定理，時空を伝搬する粒子や波の方程式に現れる</span
        ><span>変数分離性など，ブラックホール時空の数理的な研究は1960-1970年代に黄金期を迎えます。</span
        ><span>それからおよそ50年が経過し，重力波の観測やブラックホールシャドウの撮影成功など，</span
        ><span>宇宙観測は目覚ましく進展しています。</span>
      </p><p>
        <span>&emsp;このような流れの中で，本研究会では相対論の基本に立ち戻り，流行に捉われない面白そうな</span
        ><span>理論的な研究を応援したいと考えています。発表内容は必ずしも完成したものである必要は</span
        ><span>ありません。本研究会での発表や議論が問題解決の糸口，新しい研究課題，共同研究などを</span
        ><span>見出す機会となる事を期待します。</span>
      </p>
    </div>
    <hr>

    <br>

    <h3>開催概要</h3>
    <hr>
    <div class="overview">
      <div class="tit">開催日</div>
      <div class="cont">
        <s>2020年3月20日(金･祝) - 22日(日)</s>
      </div>

      <div class="tit">会場</div>
      <div class="cont">
        大阪市立大学杉本キャンパス 理学部棟<br>
        3/20：F216 第８講義室<br>
        3/21,22：E108 理学部会議室<br>
        <p>
          〒558-8585 大阪府大阪市住吉区杉本町3-3-134<a href="https://www.osaka-cu.ac.jp/ja/about/university/access#sugimoto"
          target="_blank">【アクセス】</a>
        </p>
      </div>

      <div class="tit">援助</div>
      <div class="cont">
        大阪市立大学数学研究所
        <a href="http://www.sci.osaka-cu.ac.jp/OCAMI/" target="_blank">【HP】</a>
        <p>本研究会は、大阪市立大学数学研究所、文科省共同利用・共同研究拠点「数学・理論物理の共同・共創による新たな国際的研究・教育拠点」の活動の一環として開催されます。</p>
      </div>

      <div class="tit">招待講演者（50音順、敬称略）</div>
      <div class="cont">
        石井 貴昭（京都大）<br>
        小笠原 康太（京都大）<br>
        木村 匡志（立教大）<br>
        古池 達彦（慶応大）<br>
        孝森 洋介（和歌山高専）<br>
        富沢 真也（東京工科大）<br>
        中野 寛之（龍谷大）<br>
        野澤 真人（基礎物理学研究所）<br>
        野田 知宣（明治薬科大）<br>
        道下 洋二（鹿児島大）<br>
        森山 翔文（大阪市大）<br>
        吉野 裕高（大阪市大）<br>
        柳 哲文（名古屋大）<br>
      </div>

      <div class="tit">世話人</div>
      <div class="cont">
        石原秀樹<span>（大阪市立大学理学研究科）</span><br>
        棚橋典大<span>（九州大学マス・フォア・インダストリ研究所）</span><br>
        宝利剛<span>（舞鶴工業高等専門学校）</span><br>
        安井幸則<span>（摂南大学基礎理工学機構教授/大阪市立大学数学研究所客員教授）</span>
      </div>

      <div class="tit">懇親会</div>
      <div class="cont">
        <s>3/20 (金)<br>
        会場（未定）<br></s>
        <h5>
        ※参加を希望される方は、参加登録の際に、「懇親会参加予定」の項目で「参加します」にチェックしてください。
        会場の予約の都合がありますので、懇親会に参加を希望される方は3月14日(土)までに参加登録をお願いいたします。
        </h5>
      </div>
      <!-- <div class="cont fee">
        <table align="center" border="0">
          <tr><td rowspan="2">懇親会</td>
            <td style="text-align:right;">スタッフ</td><td>5,000円</td></tr><tr>
            <td style="text-align:right;">学生</td><td>3,000円</td></tr>
        </table>
      </div> -->

      <div class="tit">参加費</div>
      <div class="cont">
        無料
      </div>

    </div>
    <hr>

  </div>
</template>

<script>
export default {
  name: 'Top'
}
</script>

<style scoped>

.inline-contents p {
  font-size: 1.2em;
  margin: 0;
}
.overview {
  text-align: center;
}
.tit {
  background-color: #333;
  color: white;
  font-size: 1.8em;
  margin: 0 100px;
  padding: 10px;
}
.cont {
  font-size: 1.5em;
  margin-bottom: 20px;
  padding: 20px;
}
.cont p {
  font-size: .7em;
  margin-top: 8px;
}
.cont span {
  font-size: .7em;
}
.fee table {
  border: solid 2px rgb(34,110,147);
  table-layout: fixed;
}
.fee table th, table td {
  border: dashed 1px rgb(101, 101, 101);
  padding: 2px 12px 2px 12px;
}
.fee table th {
  font-weight: normal;
  border-bottom: solid 2px rgb(34,110,147);
}

@media only screen and (max-width: 600px) {
  .overview {
    text-align: left;
  }
  .tit {
    margin: 0;
    padding: 4px;
    text-align: center;
  }
  .cont {
    padding: 10px;
  }
}

@media only screen and (max-width:430px) {
  .tit {
    padding: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Top.vue